import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "../lib/api";
import Header from "../components/Header";
import Footer from "../components/Footer";
import TopicCard from "../components/TopicCard";
import { Search } from "lucide-react";
import { trackSearch } from "../lib/analytics";

export default function SearchPage() {
    const [params, setParams] = useSearchParams();
    const initialQ = params.get("q") || "";
    const [q, setQ] = useState(initialQ);
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const query = params.get("q") || "";
        if (!query) { setResults([]); return; }
        setLoading(true);
        api.get(`/search?q=${encodeURIComponent(query)}`)
            .then((r) => {
                const data = r.data || [];
                setResults(data);
                trackSearch(query, data.length);
            })
            .catch(() => setResults([]))
            .finally(() => setLoading(false));
    }, [params]);

    const submit = (e) => {
        e.preventDefault();
        setParams({ q });
    };

    return (
        <div className="min-h-screen bg-[#0B1220]">
            <Header />
            <section className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-8">
                <div className="text-[10px] uppercase tracking-[0.25em] text-[#56CCF2] font-medium mb-4">Search</div>
                <h1 className="text-3xl sm:text-4xl font-bold text-white mb-8">Search the library</h1>

                <form onSubmit={submit} className="flex items-center bg-[#111827] border border-[#243044] rounded-xl px-4 py-3 focus-within:border-[#2F80ED] transition-colors">
                    <Search className="w-5 h-5 text-[#64748B]" />
                    <input
                        data-testid="search-input"
                        type="text"
                        value={q}
                        onChange={(e) => setQ(e.target.value)}
                        placeholder="Search topics, tags, summaries…"
                        autoFocus
                        className="bg-transparent border-0 outline-none text-base text-white placeholder-[#64748B] ml-3 flex-1"
                    />
                    <button type="submit" className="ml-3 px-4 py-1.5 text-xs font-medium uppercase tracking-wider rounded-lg bg-[#2F80ED] text-white hover:bg-[#2F80ED]/90 transition-colors" data-testid="search-submit">
                        Search
                    </button>
                </form>
            </section>

            <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-16">
                {loading ? (
                    <div className="text-center text-sm text-[#64748B] py-20">Searching…</div>
                ) : initialQ && results.length === 0 ? (
                    <div className="text-center py-20">
                        <p className="text-[#94A3B8]">No results for "{initialQ}"</p>
                    </div>
                ) : results.length > 0 ? (
                    <>
                        <p className="text-sm text-[#64748B] mb-6">
                            {results.length} result{results.length === 1 ? "" : "s"} for "{initialQ}"
                        </p>
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                            {results.map((t) => (<TopicCard key={t.id || t.slug} topic={t} />))}
                        </div>
                    </>
                ) : null}
            </section>
            <Footer />
        </div>
    );
}
